import { lazy } from 'react'

import { SEOPageRBAC } from '../pages/SEO/rbac'

export type SEONamedRoutesType = 'SEORouter'
export type SEOPathListsType = '/dashboard/seo-product/:id'

type RouterInstanceType = RouterFeatureInterface<SEONamedRoutesType, SEOPathListsType>

const SEOPage = lazy(() => import('../pages/SEO'))

export const SEORouter: RouterInstanceType = {
  name: 'SEORouter',
  Component: SEOPage,
  path: '/dashboard/seo-product/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SEOPageRBAC.pageID,
}

const SEORouterList: RouterInstanceType[] = [SEORouter]

export default SEORouterList
